import { COOKIE_DELIMITER, CookieCategory } from './config';

export default function isCztCookie(cookie: string): boolean {
  const regex = `[${CookieCategory.REQUIRED}][01]${COOKIE_DELIMITER}[${CookieCategory.ANALYTICS}][01]${COOKIE_DELIMITER}[${CookieCategory.STATISTICS}][01]${COOKIE_DELIMITER}[${CookieCategory.MARKETING}][01]`;
  return cookie.match(regex) !== null;
}
